import React, { useEffect, useState } from 'react';
import M_PER_CUSTOM from './M_PER_CUSTOM';
import { useDispatch } from 'react-redux';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import useFcmHandler from '../../../../Hooks/useFcmHandler';
import { useSelector } from 'react-redux';
import { NavBarInfoActions } from '../../../../Reducer/NavBarInfoReducer';
import { PermitActions } from '../../../../Reducer/PermitReducer';
import {
  useSave1,
  useSave2,
  useSearch1,
  useSearch2,
  useSearch3,
  useSearch4,
} from './M_PER_CUSTOM_Query';
import { useSave } from '../../../../Hooks/useSave';
import { M_PER_CUSTOM_Schema } from './M_PER_CUSTOM_Schema';
import { normalizeApprovalLine } from '../utils/approvalLine';

export default function M_PER_CUSTOMF() {
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const { searchRequestId, depApproval } = useSelector((state) => state.permit);
  const dispatch = useDispatch();
  const [rowData1, setRowData1] = useState([]);
  const [recentApproverRows, setRecentApproverRows] = useState(null);

  const sendFcm = useFcmHandler();

  useEffect(() => {
    dispatch(NavBarInfoActions.setType('permit'));
    dispatch(CommonActions.resetActiveStep());
    dispatch(PermitActions.resetApprovalLine());

    Search2();
  }, [dispatch]);

  useEffect(() => {
    Search1();
  }, [searchRequestId]);

  useEffect(() => {
    if (recentApproverRows === null || depApproval.length === 0) return;

    dispatch(
      PermitActions.initializeApprovalLine(
        normalizeApprovalLine(recentApproverRows, depApproval)
      )
    );
  }, [recentApproverRows, depApproval, dispatch]);

  // 작업허가서 리스트 조회
  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      setRowData1(rows);

      if (rows.some((item) => item.gubun === '요청')) {
        dispatch(PermitActions.setPermitAlarm('요청'));
      } else if (rows.some((item) => item.gubun === '반려')) {
        dispatch(PermitActions.setPermitAlarm('반려'));
      }
    },
  });

  const { run: Search2 } = useSearch2({
    onSuccess: (rows) => {
      const grouped = rows.reduce((acc, curr) => {
        const { depCd, depNmLast } = curr;

        if (!acc[depCd]) {
          acc[depCd] = {
            depCd: depCd,
            depNm: depNmLast,
            managers: [],
          };
        }

        acc[depCd].managers.push({
          id: curr.id,
          name: curr.name,
          position: curr.position,
          photo: curr.photo,
          tel: curr.tel,
        });

        return acc;
      }, {});

      const finalData = Object.values(grouped);
      dispatch(PermitActions.setDepApproval(finalData));
    },
  });

  const { refetch: Search3 } = useSearch3({
    onSuccess: (rows) => {
      dispatch(PermitActions.setCalendarDots(rows));
      console.log(rows);
    },
  });
  useSearch4({
    onSuccess: (rows) => {
      setRecentApproverRows(rows ?? []);
    },
  });
  // 연장신청할 때 필요
  const { mutateAsync: save1Async } = useSave1();
  const { mutateAsync: save2Async } = useSave2();

  const { run: Save1 } = useSave({
    menuId: 'M_PER_CUSTOM',
    schema: M_PER_CUSTOM_Schema,
    requestSave: async (rows) => {
      const row = rows[0];

      await save1Async(row);

      if (row.depHeads) {
        const heads = Object.values(row.depHeads);
        for (const head of heads) {
          if (head?.headId) {
            await save2Async({ ...row, currentHead: head });
          }
        }
      }
    },
    onSuccess: async ({ requestRows }) => {
      const data = requestRows[0];

      if (data.depHeads) {
        const heads = Object.values(data.depHeads);
        for (const head of heads) {
          if (head?.headId) {
            try {
              await sendFcm({
                targetUserId: head.headId,
                requestUserId: userInfo.userid,
                title: '작업허가서 연장 신청',
                body: '작업 종료시간 연장 승인 요청이 있습니다.',
                status: '요청',
                codeGroup: 'AL_002_004',
                route: '/M_Permit',
                responseData: data.pmCd,
              });
            } catch (err) {
              console.error('FCM 전송 실패:', err);
            }
          }
        }
      }

      await Search1();
    },
  });

  const refreshClick = async () => {
    await Search1();
  };

  return (
    <div>
      <M_PER_CUSTOM
        rowData1={rowData1}
        // 함수
        SearchLogic1={Search1}
        SaveLogic1={Save1}
        refreshClick={refreshClick}
      />
    </div>
  );
}
